import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Spinner from "../components/common/Spinner";
import { AuthContext } from "../contexts/AuthContextProvider";

const Protect = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <Spinner />;
  }
  if (user) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace></Navigate>;
};

export default Protect;
